import React from "react";
import styled from "styled-components";

const TocWrapper = styled.aside`
  position: sticky;
  top: 10px;
  width: 100%;
  max-width: 244px;
  box-sizing: border-box;
`;

/* Figma: "Table of contents" 20px bold #1A202C, generous margin below */
const TocTitle = styled.h2`
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  line-height: var(--Typography-Line-height-28, 28px);
  letter-spacing: 0;
  color: #1a202c;
  margin: 0 0 16px 0;
  text-align: left;
`;

const TocList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 0 0 12px;
  border-left: 1.5px solid var(--slate-200, #E2E8F0);
`;

const TocItem = styled.li`
  margin-bottom: 0.75em;
  padding-left: ${(props) => (props.$level > 1 ? (props.$level - 1) * 12 : 0)}px;
`;

/* Figma: list 16px 400; active #3182CE, inactive #718096 */
const TocLink = styled.button`
  font-family: var(--Typography-font-family, Inter);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: var(--Typography-Line-height-20, 20px);
  line-spacing: 10px;
  color: ${(props) => (props.$active ? "#000000" : "#718096")};
  text-decoration: none;
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  &:hover {
    color: #1a202c;
  }
`;

export default function TableOfContents({ items = [], activeId = null, onScrollToSection }) {
  if (!items.length) return null;

  return (
    <TocWrapper>
      <TocTitle>Table of contents</TocTitle>
      <TocList>
        {items.map(({ id, text, level }) => (
          <TocItem key={id} $active={activeId === id} $level={level}>
            <TocLink
              type="button"
              $active={activeId === id}
              onClick={() => onScrollToSection?.(id)}
            >
              {text}
            </TocLink>
          </TocItem>
        ))}
      </TocList>
    </TocWrapper>
  );
}
